import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../_services/authentication.service';
import { PortalAuthenticationService } from '../../features/portal/_services/portal-authentication.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthenticationService, //used for the main app and portal management
    private portalAuthenticationService: PortalAuthenticationService //used for the portal
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<HttpEvent<any>>> {
    const systemUser = this.authenticationService.userValue;
    const portalUser = this.portalAuthenticationService.portalUserValue;

    if (this.authenticationService.isResponsibleFor(request) && systemUser?.access_token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${systemUser.access_token}`
        }
      });
      console.log('JWT Interceptor: Adding token for system user');
    } else if (
      this.portalAuthenticationService.isResponsibleFor(request) &&
      portalUser?.access_token
    ) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${portalUser.access_token}`
        }
      });
      console.log('JWT Interceptor: Adding token for portal user');
    }

    return next.handle(request);
  }
}
